import React from 'react';

interface SVGEMailProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGEMail = ({
  width = '20',
  height = '20',
  color = '#000',
  strokeWidth = '2',
}: SVGEMailProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8 3H17.2C18.19 3 19 3.7875 19 4.75V15.25C19 16.2125 18.19 17 17.2 17H2.8C1.81 17 1 16.2125 1 15.25V4.75C1 3.7875 1.81 3 2.8 3Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 4C18 4 14 10 10 10C6 10 2 4 2 4"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGEMail;
